export default __webpack_public_path__ + "static/media/mobile.5bed782e.jpg";